module.exports = __webpack_public_path__ + "img/text-ueberweisung.e454b36e.png";